var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMitLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 28",
    style: {
      enableBackground: "new 0 0 54 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    className: "st0",
    width: 15,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.8,
    className: "st0",
    width: 6,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    className: "st0",
    width: 6,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 6,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 10,
    className: "st0",
    width: 6,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    className: "st0",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 10,
    className: "st0",
    width: 6,
    height: 18
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitLogoWhite);
export default __webpack_public_path__ + "static/media/MIT-logo-white.b86c973efb66f7bd9aa856225bdb4d19.svg";
export { ForwardRef as ReactComponent };